import React from 'react';
type Props = {
  minorDistance: number;
  minorCount: number;
  minorStrokeWidth: number;
  majorStrokeWidth: number;
  color: string;
};
export default function Grid(props: Props) {
  const {
    minorDistance,
    minorCount,
    minorStrokeWidth,
    majorStrokeWidth,
    color
  } = props;
  const majorGridSize = minorDistance * minorCount;
  return <React.Fragment>
      <defs>
        <pattern id="smallGrid" width={minorDistance} height={minorDistance} patternUnits="userSpaceOnUse">
          <path d={`M ${minorDistance} 0 L 0 0 0 ${minorDistance}`} fill="none" stroke={color} strokeWidth={minorStrokeWidth} />
        </pattern>
        <pattern id="grid" width={majorGridSize} height={majorGridSize} patternUnits="userSpaceOnUse">
          <rect width={majorGridSize} height={majorGridSize} fill="url(#smallGrid)" />
          <path d={`M ${majorGridSize} 0 L 0 0 0 ${majorGridSize}`} fill="none" stroke={color} strokeWidth={majorStrokeWidth} />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)" />
    </React.Fragment>;
}
Grid.defaultProps = {
  minorDistance: 10,
  minorCount: 3,
  minorStrokeWidth: 0.5,
  majorStrokeWidth: 1,
  color: 'gray'
};